<div
  *ngIf="availablePaymentMethods"
  class="w-full md:mx-auto md:max-w-md"
>
  <div class="lg:mt-12 lg:mb-12 kiosk:mt-12 kiosk:mb-16">
    <h1 class="hidden mt-6 mb-3 text-5xl font-bold text-center md:block font-accent">
      {{ 'payment.title' | translate }}
    </h1>
    <h2
      *ngIf="availablePaymentMethods.length > 1"
      class="px-5 mt-5 mb-3 font-bold font-accent md:mt-6 text-md md:text-center"
    >
      {{ 'payment.subtitle' | translate }}
    </h2>
  </div>
  <div class="border-t md:border md:rounded-s">
    <div
      class="border-b border-neutral-300"
      *ngFor="let paymentMethod of availablePaymentMethods"
      [class.disabled]="status.isRetryInProgress && paymentMethod !== selectedPaymentMethod"
    >
      <div class="flex flex-col px-5 cursor-pointer text-neutral-600">
        <div
          class="py-4.5 flex justify-between items-center"
          (click)="
            availablePaymentMethods.length > 1
              ? selectPaymentMethod(paymentMethod)
              : $event.stopPropagation()
          "
        >
          <div class="flex items-center w-4/6">
            <span
              class="text-xs pr-1.5"
              *ngIf="availablePaymentMethods.length > 1"
            >
              <input
                type="radio"
                [checked]="paymentMethod === selectedPaymentMethod"
                class="form-radio border-2 p-1.5 bg-none m-2 border-neutral-400"
                [ngClass]="{
                  'p-2.5 bg-primary-600 border-primary-600 m-1 shadow-custom':
                    paymentMethod === selectedPaymentMethod,
                }"
              />
            </span>
            <span *ngIf="paymentMethod.label !== 'payment.on-site'">{{
              paymentMethod.label | translate
            }}</span>
          </div>
          <div class="flex justify-end w-2/6">
            <img
              alt="logo"
              [src]="logo"
              class="ml-2 max-h-6"
              *ngFor="let logo of paymentMethod.logos"
            />
          </div>
        </div>
        <app-component-factory
          [componentClass]="paymentMethod.panelComponent"
          [data]="paymentMethod.data"
          *ngIf="paymentMethod === selectedPaymentMethod"
        ></app-component-factory>
      </div>
    </div>
    <div class="hidden md:block">
      <div
        class="flex justify-between pt-4 text-center"
        *ngIf="error as paymentErrorMessage"
      >
        <span class="font-base text-error-600">
          {{ paymentErrorMessage | translate }}
        </span>
      </div>
      <div class="pt-8 text-center">
        <span class="mr-1.5 font-bold font-accent text-2xl">Total</span>
        <div class="md:hidden">
          <app-price-atom
            format="true"
            [size]="'MD'"
            [amount]="amount"
          ></app-price-atom>
        </div>
        <div class="hidden md:inline-block">
          <app-price-atom
            format="true"
            [size]="'2XL'"
            [amount]="amount"
          ></app-price-atom>
        </div>
      </div>

      <div class="flex justify-center pt-4 mb-10">
        <app-button-atom
          *ngIf="button.isVisible === true"
          [icon]="!(status.isInProgress || status.isLoading) ? 'icon-black-lock' : undefined"
          [iconUrl]="
            status.isInProgress || status.isLoading ? 'assets/images/spinner.svg' : undefined
          "
          [size]="'M'"
          [type]="'primary'"
          (click)="triggerPayment()"
          [label]="
            (button.text === 'payment.validate-on-site' &&
            (order$ | async)?.[orderKeys.FinalPrice] === 0
              ? 'payment.validate-on-site-zero'
              : button.text
            ) | translate
          "
          [disabled]="!button.isEnabled || status.isInProgress"
        ></app-button-atom>
      </div>
    </div>
  </div>
</div>

<div class="fixed bottom-0 left-0 right-0 z-30 bg-white shadow md:hidden shadow-top">
  <div class="container mx-auto p-4 pt-4.5 align-middle">
    <div
      class="flex justify-between"
      *ngIf="error"
    >
      <span class="font-base text-error-600">
        {{ error | translate }}
      </span>
    </div>
    <div
      *ngIf="amount"
      class="flex items-center justify-center"
    >
      <span class="mr-1.5 font-bold font-accent text-md">Total</span>
      <app-price-atom
        format="true"
        [size]="'MD'"
        [amount]="amount"
      ></app-price-atom>
    </div>
    <div *ngIf="hasErrorMessages">
      <p
        class="px-4 pt-4 text-base font-normal text-error-700"
        *ngFor="let message of errorMessages"
      >
        {{ message }}
      </p>
    </div>
    <div
      class="pt-4.5"
      *ngIf="button.isVisible === true"
    >
      <app-button-atom
        [icon]="!(status.isInProgress || status.isLoading) ? 'icon-black-lock' : undefined"
        [iconUrl]="
          status.isInProgress || status.isLoading ? 'assets/images/spinner.svg' : undefined
        "
        [size]="'L'"
        [type]="'primary'"
        (click)="triggerPayment()"
        [label]="button.text | translate"
        [disabled]="!button.isEnabled || status.isInProgress || hasErrorMessages"
      ></app-button-atom>
    </div>
  </div>
</div>
